import { Box, styled, Typography } from '@mui/joy';
import { CSSProperties } from 'react';

export const autocompleteOptionPartNumberStyle: CSSProperties = {};

export const popupIndicatorStyle = (showPopupIndicator = true): CSSProperties => ({
  display: showPopupIndicator ? 'block' : 'none',
  fontSize: 10,
});

export const LoaderWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
});

export const CreateNewOptionValueWrapper = styled(Typography)({
  display: 'flex',
  alignItems: 'center',
  fontWeight: 600,
  gap: '8px',
});
